import axios from '../../axios';

export default {
  namespaced: true,

  state: {
    currentBookingPassportDetails: null,
    allItalyProvinces: [],
  },

  getters: {
    currentBookingPassportDetails: (state) => state.currentBookingPassportDetails,
    allItalyProvinces: (state) => state.allItalyProvinces,
  },

  mutations: {
    setCurrentBookingPassportDetails(state, data) {
      state.currentBookingPassportDetails = data;
    },
    setAllItalyProvinces(state, data) {
      state.allItalyProvinces = data;
    },
  },

  actions: {

    updateCurrentBookingPassportDetails({ commit, getters, rootGetters }, data) {
      return new Promise((resolve, reject) => {
        axios.post(`/core/passportdetails/bookingid/${data.id}`, data.passportDetails).then((res) => {
          commit('setCurrentBookingPassportDetails', res.data);
          resolve(res);
        }).catch((error) => { reject(error); });
      });
    },

    addRowToCurrentBookingPassportDetails({ commit, getters, rootGetters }) {
      return new Promise((resolve, reject) => {
        axios.post(`/core/passportdetails/bookingid/${rootGetters['bookings/currentBooking'].id}/addextrarow`).then((res) => {
          commit('setCurrentBookingPassportDetails', res.data);

          resolve(res);
        }).catch((error) => { reject(error); });
      });
    },

    fetchBookingPassportDetails({
      state, commit, getters, rootGetters,
    }, booking) {
      return new Promise((resolve, reject) => {
        axios.get(`/core/passportdetails/bookingid/${booking.id}`).then((res) => {
          resolve(res.data);
        }).catch((error) => { reject(error); });
      });
    },

    fetchCurrentBookingPassportDetails({
      state, commit, getters, rootGetters,
    }) {
      return new Promise((resolve, reject) => {
        state.currentBookingPassportDetails = null;

        if (rootGetters['bookings/currentBooking']) {
          axios.get(`/core/passportdetails/bookingid/${rootGetters['bookings/currentBooking'].id}`).then((res) => {
            // console.log('data:' + res.data[0])
            commit('setCurrentBookingPassportDetails', res.data);
            resolve(res);
          }).catch((error) => { reject(error); });
        } else {
          resolve(null);
        }
      });
    },

    fetchPassportDetailsByBookingId({ state, commit }, id) {
      return new Promise((resolve, reject) => {
        state.currentBookingPassportDetails = null;

        if (id) {
          axios.get(`/core/passportdetails/bookingid/${id}`).then((res) => {
            // console.log('data:' + res.data[0])
            commit('setCurrentBookingPassportDetails', res.data);
            resolve(res.data);
          }).catch((error) => { reject(error); });
        } else {
          resolve(null);
        }
      });
    },

    archivePassport({ commit, dispatch, getters }, guestId) {
      return new Promise((resolve, reject) => {
        axios.post(`/core/passportdetails/guestid/${guestId}/archive`).then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
      });
    },

    fetchAllItalyProvinces({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('/core/passportdetails/italyprovinces').then((res) => {
          commit('setAllItalyProvinces', res.data);
          resolve(res);
        }).catch((error) => { reject(error); });
      });
    },

    getAllItalyCommunesByProvinceCode({ }, provinceCode) {
      return new Promise((resolve, reject) => {
        axios.get(`/core/passportdetails/italyprovinces/${provinceCode}/communes`).then((res) => {
          resolve(res);
        }).catch((error) => { reject(error); });
      });
    },

  },

};
